var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMassaccounting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 26.784,
    cy: 29.904,
    r: 1.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M6.235 6.226h31.596v6.053H6.235zM21.141 12.279v22.422"
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M8.404 20.159h6.973M8.404 29.456h6.973M26.784 20.159h6.973"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMassaccounting);
export default __webpack_public_path__ + "static/media/massaccounting.c01224cd78388b5fd50f29c2fdaf135a.svg";
export { ForwardRef as ReactComponent };